import { FC, useCallback } from "react";

import { getCurrentUrlWithParams } from "../../utils/utils";
import { useScreenManager } from "../../hooks/use-screen-manager";

import CodingAgentChoiceView from "./coding-agent-choice";
import { CodingAgentId } from "./types";

/**
 * Container that wires the dumb {@link CodingAgentChoiceView} into the
 * confirmation-page screen pipeline.
 *
 * On submit:
 *  - Persists the selected agent IDs as a comma-separated `coding_agents`
 *    query param so the choice survives a refresh and the screen is skipped
 *    on re-entry.
 *  - Advances the screen manager to the next screen.
 *
 * TODO (TWCG-1935):
 *  - fire analytics: viewed / agentToggled / submitted.
 */
export const CodingAgentChoiceController: FC = () => {
    const { nextScreen } = useScreenManager();

    const handleSubmit = useCallback(
        (selected: CodingAgentId[]) => {
            const agentsValue =
                selected.length > 0 ? selected.join(",") : "NONE";
            const updatedUrl = getCurrentUrlWithParams({
                coding_agents: agentsValue
            });
            window.history.replaceState({}, "", updatedUrl);
            nextScreen();
        },
        [nextScreen]
    );

    return <CodingAgentChoiceView onSubmit={handleSubmit} />;
};
